import { RootState } from "@/models/RootState.type";
import { AppDispatch } from "@/models/AppDispatch.type";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { fetchSkillResources, updateResourcesQueue } from "../slices";

export const addUpdateResourcesQueueListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: updateResourcesQueue,
    effect: async (action: any, listenerApi: any) => {
    
      try {
        const { weeklyPlan } = listenerApi.getState() as RootState;
        if (
          weeklyPlan.data?.resourcesFetchQueue &&
          weeklyPlan.data.resourcesFetchQueue.length
        ) {
          let resourcesFetchQueue = [...weeklyPlan.data.resourcesFetchQueue];
          const resourceInput = resourcesFetchQueue.pop();
          if (resourceInput) {
            listenerApi.dispatch(fetchSkillResources({ input: resourceInput }));
          }

          // doing async dispatch
          resourcesFetchQueue = [...weeklyPlan.data.resourcesFetchQueue];
          resourcesFetchQueue.pop();
          listenerApi.dispatch(updateResourcesQueue(resourcesFetchQueue));
        }
      } catch (error) {
        console.error("Error fetching skill resources in queue", error);
        // listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
      }
    },
  });
};
